import { EVENT_CLOSE, EVENT_ERROR } from "manifest-bridge-core/src/events";
import { CloseParams, ErrorParams } from "../typings";

const generateURIRedirect = ({
  event,
  closeData,
  errorData = undefined,
}: {
  event: typeof EVENT_CLOSE | typeof EVENT_ERROR;
  closeData?: CloseParams;
  errorData?: ErrorParams;
}): string => {
  const scheme = "manifestbridge";
  const action = event === EVENT_CLOSE ? "exit" : event === EVENT_ERROR ? "error" : "";
  const searchParams = new URLSearchParams();

  if (closeData) {
    searchParams.append("transferIntentStatus", closeData.transferIntentStatus);
    searchParams.append("transferIntentId", closeData.transferData.transferIntentId);
    if (closeData.transferData.transferId) {
      searchParams.append("transferId", closeData.transferData.transferId.join(","));
    }
    if (closeData.transferData.userId) {
      searchParams.append("userId", closeData.transferData.userId);
    }
  }

  if (errorData) {
    searchParams.append("errorCode", errorData.errorCode);
    searchParams.append("errorMessage", errorData.errorMessage);
  }

  return `${scheme}://${action}?${searchParams.toString()}`;
};

export default generateURIRedirect;
